import { FC, useCallback, useEffect } from "react";

import { useSearchParams } from "next/navigation";
import { useSnapshot } from "valtio";
import { I18nUtil } from "@utils/i18n";
import { RedeemCodeModalCreateAble } from "@components/modal/RedeemCode";
import Translations from "@translate/components/Member/CurrentPlan/GiftCodeSection";
import { rootStore } from "@store/rootStore";
import {
  INVITE_SPREAD_CODE_PARAM,
  handleInviteSpreadCodeFromLink,
} from "./inviteSpreadCodeLink";
const I18n = I18nUtil.createScoped(Translations);

/**
 * 礼品码兑换入口组件
 * 基于Figma设计稿实现底部文案和兑换入口
 */
export const GiftCodeSection: FC = () => {
  const searchParams = useSearchParams();
  const inviteSpreadCode =
    searchParams.get(INVITE_SPREAD_CODE_PARAM)?.trim() ?? "";
  const { isLoggedIn, isLoading, isFetching } = useSnapshot(rootStore.login);
  // 登录态未确定时不处理链接码：否则会把正在恢复登录的用户误判为未登录送去登录页
  const isLoginResolved = isLoggedIn || (!isLoading && !isFetching);

  // 处理兑换码点击
  const handleConvertClick = useCallback(async () => {
    await RedeemCodeModalCreateAble({
      code: inviteSpreadCode || null,
      source: "manual",
    });
  }, [inviteSpreadCode]);

  useEffect(() => {
    if (!inviteSpreadCode || !isLoginResolved) {
      return;
    }
    void handleInviteSpreadCodeFromLink(inviteSpreadCode, !!isLoggedIn);
  }, [inviteSpreadCode, isLoginResolved, isLoggedIn]);

  return (
    <div className="flex flex-col items-center justify-center p-4 md:py-10 md:px-0 w-full">
      <div className="flex body_bold_m md:body_medium_l gap-[12px] items-center text-center">
        <p className="text-content_primary">{I18n.t("Have a Gift Code？")}</p>
        <button
          aria-label="Gift Code Section"
          data-openreplay-label="member_giftcodesection_click"
          id="btn-gift-code-section"
          onClick={handleConvertClick}
          className="text-content_brand_primary underline hover:text-content_brand_primary_hover transition-colors cursor-pointer bg-transparent border-none p-0"
        >
          {I18n.t("Convert")}
        </button>
      </div>
    </div>
  );
};
